import styled from '@emotion/styled'
import { MediaQuery } from '@pharmac-extranet/shared'
import { PropsWithChildren } from 'react'

type ExtranetWrapperProps = PropsWithChildren

const ExtranetWrapperRoot = styled.div<ExtranetWrapperProps>`
  width: var(--extranet-wrapper-width);
  margin: var(--spacing-small) auto;
  padding-bottom: var(--spacing-large);

  ${MediaQuery.maxTablet} {
    margin: 0;
    width: 100%;
  }
`

export const ExtranetWrapper = (props: ExtranetWrapperProps) => {
  return <ExtranetWrapperRoot className="ExtranetWrapperRoot">{props.children}</ExtranetWrapperRoot>
}
